import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";
import { enqueueSnackbar } from "notistack";

export function useDeleteSettingKey() {
  const [deleteMutation, { loading }] = useMutation<any>(
    mutations.deleteSettingKey,
    {
      errorPolicy: "all",
    },
  );

  const deleteSettingKey = useCallback(
    async (id: string) => {
      try {
        const res = await deleteMutation({
          variables: { id },
          refetchQueries: ["SettingKeys"],
        });
        const result = res.data?.deleteSettingKey;
        if (result?.success) {
          enqueueSnackbar(result.message?.[0] || "Key deleted successfully!", {
            variant: "success",
          });
          return true;
        } else {
          enqueueSnackbar(result?.message?.[0] || "Failed to delete key", {
            variant: "error",
          });
          return false;
        }
      } catch (err: any) {
        enqueueSnackbar(err.message || "An error occurred", {
          variant: "error",
        });
        return false;
      }
    },
    [deleteMutation],
  );

  return {
    deleteSettingKey,
    loading,
  };
}
